import React from 'react';
import { PAGES_SHOWN } from '../../metadata/fields';
import { useWindowDimensions } from '../../metadata/hooks';

function Pagination({ page, setPage, maxPages }) {
    const { _, width } = useWindowDimensions();
    const CALCULATED_PAGES_SHOWN = PAGES_SHOWN(width);
    const divisor = Math.floor(CALCULATED_PAGES_SHOWN / 2)
    const showLowerEllipses = maxPages > CALCULATED_PAGES_SHOWN && page > divisor;
    const showHigherEllipses = maxPages > CALCULATED_PAGES_SHOWN && page < maxPages - divisor - 1;
    const buttonExtension = showHigherEllipses && showLowerEllipses ? 0 : 2;
    const offset = page <= divisor || maxPages <= CALCULATED_PAGES_SHOWN ?  -page : page >= maxPages - divisor - 1 ? maxPages - CALCULATED_PAGES_SHOWN - page - 2 : -divisor;
    const pageButtons = Array.from({ length: maxPages > CALCULATED_PAGES_SHOWN ? CALCULATED_PAGES_SHOWN + buttonExtension : maxPages }, (_, index) => (
        <button key={index} className={ page + index + offset  === page ? 'active ' : '' } onClick={ ()=> setPage(page + index + offset) }>{ page + index + offset + 1 }</button> 
    ));

    const backButton = maxPages > 0 ? <button onClick={ ()=> setPage(page - 1) } disabled={page === 0}>«</button> : null; 

    const forwardButton = maxPages > 0 ? <button onClick={ ()=> setPage(page + 1) } disabled={page === maxPages - 1}>»</button> : null;

    const lowerEllipsesButton = showLowerEllipses ? (
        <>
            <button onClick={ () => setPage(0) }>1</button>
            <button disabled>...</button>
        </>
    ): null;
    const higherEllipsesButton = showHigherEllipses ? (
        <>
            <button disabled>...</button> 
            <button onClick={ () => setPage(maxPages - 1) }>{ maxPages }</button>
        </>
    ): null;

    return (
        <section className="clanleaderboard_pagination">
            { backButton }
            { lowerEllipsesButton } 
            { pageButtons }
            { higherEllipsesButton } 
            { forwardButton }
        </section>
    )
}

export default Pagination;
